export enum EventIds {
    // Global errors
    UnhandledError = 22201,
    UppyUploadError = 22202,
    SubmissionFailed = 22203,
    TokenValidationError = 22204,
    SubmissionSuccess = 22205,
}
